export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_title_displayImportMsg') || '错误/警告信息',
    field: 'displayImportMsg',
    headerAlign: 'center',
    align: 'left',
    width: 300,
    slots: { default: 'displayImportMsg' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_workLogTime') || '报工日期',
    field: 'workLogTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_ncNo') || '子件编码',
    field: 'ncNo',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_workShiftName') || '班次',
    field: 'workShiftName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_processName') || '报工工序',
    field: 'processName',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_techName') || '工序工艺',
    field: 'techName',
    align: 'center',
    width: 220,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_reportedWorkQty') || '报工数量',
    field: 'reportedWorkQty',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_totalActualTime') || '实际耗时（分钟）',
    field: 'totalActualTime',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_reportPerson') || '报工人员',
    field: 'reportPerson',
    align: 'center',
    width: 170,
    slots: { default: 'displayReportPerson' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_breakReasonName') || '中断原因',
    field: 'breakReasonName',
    align: 'center',
    width: 220,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_title_breakDuration') || '中断时长（分钟）',
    field: 'breakDuration',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
]
